<template>
  <div class="page">
    <div class="page-content">
      <template v-for="(item, index) in certificateGuideList" :key="index">
        <div class="page-content-item">
          <div class="content-title" v-html="item.title"></div>
          <div v-if="item.tips" class="content-tips" v-html="item.tips"></div>
          <div class="content-detail">
            <img :src="item.img" alt="" :style="{ ...item.imgStyle }" />
          </div>
        </div>
      </template>
    </div>
    <div class="bottom-handler">
      <div class="btns">
        <span class="positive-btn" :class="{ disabled: positiveButtonDisabled }" @click="onClickConfirmInstallation">{{
          $t('owork_base.certificate.success')
        }}</span>
      </div>
      <div class="tips">
        {{ $t('owork_base.certificate.failed_re_download')
        }}<span class="reDownload" @click="downloadCertificate">{{ $t('owork_base.certificate.re_download') }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { CSSProperties } from 'vue'
  import { onMounted, ref } from 'vue'
  import macStep1 from '@assets/svgs/preload-cert-install-step1-mac.png'
  import macStep2 from '@assets/svgs/preload-cert-install-step2-mac.png'
  import macStep3 from '@assets/svgs/preload-cert-install-step3-mac.png'
  import macStep4 from '@assets/svgs/preload-cert-install-step4-mac.png'
  import macStep5 from '@assets/svgs/preload-cert-install-step5-mac.png'
  import macStep6 from '@assets/svgs/preload-cert-install-step6-mac.png'
  import winStep1 from '@assets/svgs/cert-install-step1-windows.png'
  import winStep2 from '@assets/svgs/cert-install-step2-windows.png'
  import winStep3 from '@assets/svgs/cert-install-step3-windows.png'
  import winStep4 from '@assets/svgs/cert-install-step4-windows.png'
  import winStep5 from '@assets/svgs/cert-install-step5-windows.png'
  import winStep6 from '@assets/svgs/cert-install-step6-windows.png'
  import winStep7 from '@assets/svgs/cert-install-step7-windows.png'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  defineProps<{
    positiveButtonDisabled: boolean
  }>()

  const makeTheFontBold = (str: string) => `<strong>${str}</strong>`

  type CertificateGuideList = Array<{ title: string; img: string; tips?: string; imgStyle?: CSSProperties }>

  const macCertificateGuideList: CertificateGuideList = [
    {
      title: t('owork_base.certificate.mac_guide_step1'),
      img: macStep1,
    },
    { title: t('owork_base.certificate.mac_guide_step2'), img: macStep2 },
    {
      title: t('owork_base.certificate.mac_guide_step3', { cerName: '【0Work -null - CA】' }),
      img: macStep3,
      tips: t('owork_base.certificate.mac_guide_step3_tips', { cerName: '【0Work -null - CA】' }),
    },
    { title: t('owork_base.certificate.mac_guide_step4'), img: macStep4 },
    {
      title: t('owork_base.certificate.mac_guide_step5'),
      img: macStep5,
    },
    {
      title: t('owork_base.certificate.mac_guide_step6'),
      img: macStep6,
    },
  ]
  const winCertificateGuideList: CertificateGuideList = [
    {
      title: t('owork_base.certificate.win_guide_step1'),
      img: winStep1,
    },
    {
      title: t('owork_base.certificate.win_guide_step2'),
      img: winStep2,
    },
    {
      title: t('owork_base.certificate.win_guide_step3'),
      img: winStep3,
    },
    {
      title: t('owork_base.certificate.win_guide_step4'),
      img: winStep4,
    },
    {
      title: t('owork_base.certificate.win_guide_step5'),
      img: winStep5,
      imgStyle: { width: '463.65px' },
    },
    {
      title: t('owork_base.certificate.win_guide_step6'),
      img: winStep6,
    },
    {
      title: t('owork_base.certificate.win_guide_step7'),
      img: winStep7,
    },
  ]
  const certificateGuideList = ref<CertificateGuideList>(winCertificateGuideList)
  const emit = defineEmits<{
    (e: 'installation-confirmed', checkFailedKeepDialog?: boolean): void
    (e: 'download-certificate'): void
  }>()

  const downloadCertificate = () => {
    emit('download-certificate')
  }

  const onClickConfirmInstallation = () => {
    emit('installation-confirmed', true)
  }

  const initPlatformCertificateGuideList = () => {
    // TODO: 在electron里验证
    const { platform } = navigator

    switch (platform) {
      case 'Mac68K':
      case 'MacPPC':
      case 'MacIntel':
      case 'Macintosh':
        certificateGuideList.value = macCertificateGuideList
        break
      case 'Win16':
      case 'Win32':
      case 'WinCE':
      case 'Windows':
        certificateGuideList.value = winCertificateGuideList
        break
      default:
        break
    }
  }

  onMounted(() => {
    initPlatformCertificateGuideList()
  })
</script>

<style lang="stylus" scoped>

  .page
    display flex
    flex-direction column
    justify-content center
    position relative
    .page-content
      display flex
      flex-direction column
      height 749px !important
      overflow-y auto
      padding-bottom 109px
      box-sizing border-box
      .page-content-item
        margin 36px auto 0
        &:first-child
          margin-top 26px
      .content-title
        font-size 16px
      .content-tips
        font-size 16px
        text-indent 3em
      .content-detail
        width 624px
        margin-top 16px
        & > img
          width 100%
      .content-detail-windows
        display flex
        & > img
          rect(359px, 369px)
          margin-right 61px
        .window-step1
          rect(360px, 506px)
        .window-step2
          width 360px
        .window-step4
          height 372px
    .bottom-handler
      background linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.85) 16.04%, #ffffff 100%)
      height 109px
      position absolute
      width 100%
      bottom 0
      left 0
      border-radius 0 0 12px 12px
    .btns
      display flex
      flex-direction row
      justify-content center
      margin-top 20px
      .positive-btn
        primary-btn(12px, 280px, 8px)
    .tips
      text-align center
      color default_shallow_color
      margin-top 12px
      .reDownload
        color #007bff
        cursor pointer
        &:hover
          color #006fe6
</style>
